import { Spin } from 'antd';
import React from 'react';
import './styles/LoaderComponent.less';

const LoaderComponent = (props) => {
  const {
    spinning = true,
    size = 'large',
    children,
    setHeight = 100,
    className = '',
    ...rest
  } = props;
  return (
    <Spin
      spinning={spinning}
      size={size}
      className={`common-loader d-flex justify-center align-center flex-vertical ${className}`}
      style={{
        height: `${setHeight}vh`
      }}
      {...rest}
    >
      {children}
    </Spin>
  );
};
export default LoaderComponent;
